export default {
  computed: {
    userList() {
      return this.$store.getters["member/getRealUserList"]
    },
    topShareInfo() {
      return this.$store.state.member.userList.find(i => i.isTopShare)
    },
    isExitUserShare() { // 存在用户共享
      return this.userList.find(i => i.isShare)
    },
    isExitUserLock() { // 存在锁定用户
      return this.userList.find(i => i.isDbClick)
    },
    isFocusScreen() { // 存在焦点画面
      return this.$store.state.meet.isFocusScreen
    },
    isShareDoc() {
      return this.$store.state.meet.isShareDoc
    },
    projectType() {
      return this.$store.state.meet.projectType
    },
  },

  methods: {
    dobuleClick(type, user) { // 双击事件
      if(this.isShareDoc){
        this.$totast(this.$t('使用文档共享不支持锁定'))
        return
      }
      
      if (!this.isExitUserLock) { // 如果不存在锁定用户，进行提示
        this.$totast(this.projectType == 10 || this.$configs?.businessType == '10008' ? '画面已锁定，点击右上角取消锁定' : this.$t('meeting.unLocking'));
      }

      // 重置isDbClick
      this.userList.forEach(item => {
        this.$store.commit('member/updateUser', {
          userId: item.userId,
          isDbClick: false
        })
      })

      if (type === 'tab2') { // tab2点击，特殊处理
        if (this.isExitUserShare && this.isExitUserShare.userId === user.userId) {
          console.error('命中了相同tab-----')
          window._isClickSameTab = true
        }

        if (this.topShareInfo && (this.topShareInfo.userId === user.userId)) {
          console.error('双击了tab2共享画面，这时候要执行解锁操作')

          this.$totast(this.$t('meeting.screenUnlock'))
          window._isClickTopShare = true
          this.$store.commit('member/removeShareView')

          return
        }
      }
      if (user.isTopShare) { // 双击了顶部锁定画面，这时候要执行解锁操作
        console.error('双击了顶部画面，这时候要执行解锁操作')
        
        if(this.isFocusScreen != 0){ //存在焦点画面时 锁定共享
          this.$totast(this.projectType == 10 || this.$configs?.businessType == '10008' ? '画面已锁定，点击右上角取消锁定' : this.$t('meeting.unLocking'));
          this.$store.commit('member/updateUser', {
            userId: user.userId,
            isDbClick: true
          })
        }else{
          this.$totast(this.$t('meeting.screenUnlock'))
        }
        window._isClickTopShare = true
        this.$store.commit('member/removeShareView')

      } else { // 双击了正常的list用户
        window._isLoadMainVideo = true

        this.$store.commit('member/updateUser', {
          userId: user.userId,
          isDbClick: true
        })

        if (this.isExitUserShare) { // 当前存在共享用户
          if (!this.topShareInfo) {
            window._loadTopShare = true
            // console.error(444,this.isExitUserShare.userId)
            this.$store.commit('member/unshiftUser', {
              userId: this.isExitUserShare.userId,
              isTopShare: true,
              sharePaused: this.isExitUserShare.sharePaused
            })
          }

        } else { // 当前不存在共享用户
          console.error('双击时不存在共享的用户');
        }
      }
    }
  }
}